import React, {
  useState,
  useEffect,
  useMemo
} from "react";

import "./FlueGas.css";

function FlueGas({

  x = 100,
  y = 100,

  width = 200,
  height = 400,

  Damper_Opening = 100

}) {

  const [TT_2102, setTT_2102] =
    useState(25);

  /* =====================================
     TEMPERATURE TAG
  ===================================== */

  useEffect(() => {

    const interval =
      setInterval(() => {

        setTT_2102(
          Number(
            localStorage.getItem(
              "TT_2102"
            )
          ) || 25
        );

      }, 100);

    return () =>
      clearInterval(interval);

  }, []);

  /* =====================================
     TEMPERATURE INTENSITY
     25 - 500°C
  ===================================== */

  const temperatureIntensity =
    useMemo(() => {

      if (TT_2102 < 50)
        return 0;

      return Math.min(
        (TT_2102 - 50) / 450,
        1
      );

    }, [TT_2102]);

  /* =====================================
     DAMPER EFFECT
  ===================================== */

  const damperFactor =
    1 +
    ((100 - Damper_Opening) / 100);

  /* =====================================
     FINAL FLUE GAS INTENSITY
  ===================================== */

  const flueIntensity =
    Math.min(
      temperatureIntensity *
      damperFactor,
      1
    );

  /* =====================================
     NUMBER OF PARTICLES
  ===================================== */

  const particleCount =
    Math.floor(
      10 +
      flueIntensity * 110
    );

  /* =====================================
     CREATE PARTICLES ONCE
  ===================================== */

  const particles =
    useMemo(() => {

      return [...Array(150)].map(
        (_, i) => ({

          id: i,

          left:
            Math.random() * 100,

          bottom:
            Math.random() * 25,

          size:
            2 + Math.random() * 8,

          delay:
            Math.random() * 8,

          duration:
            2 +
            Math.random() * 4

        })
      );

    }, []);

  return (

    <div

      className="flue-gas-container"

      style={{

        position: "absolute",

        left: x,
        top: y,

        width,
        height,

        overflow: "hidden",

        pointerEvents: "none",

        zIndex: 500

      }}

    >

      {

        particles
          .slice(
            0,
            particleCount
          )
          .map(
            (particle) => (

              <div

                key={particle.id}

                className="flue-particle"

                style={{

                  left:
                    `${particle.left}%`,

                  bottom:
                    `${particle.bottom}%`,

                  width:
                    `${particle.size}px`,

                  height:
                    `${particle.size}px`,

                  opacity:
                    0.1 +
                    (
                      flueIntensity *
                      0.7
                    ),

                  animationDelay:
                    `${particle.delay}s`,

                  animationDuration:
                    `${particle.duration}s`

                }}

              />

            )
          )

      }

    </div>

  );

}

export default FlueGas;